module.exports = __webpack_public_path__ + "img/TS-circle.f555b431.svg";